import React from 'react';
import clsx from 'clsx';
import { PushPin, PushPinOutlined } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '../Button/IconButton';
import { ReactComponent as KidStarOutline } from '../../assets/icons/kid_star_outline.svg?component';
import { ReactComponent as KidStarFilled } from '../../assets/icons/kid_star_filled.svg?component';

type PinButtonProps = {
	variant?: 'pin' | 'favourite';
	tooltip?: [string, string];
	className?: string;
} & IconButtonProps;

export const PinButton = React.forwardRef<HTMLButtonElement, PinButtonProps>(({
	variant = 'pin',
	tooltip,
	className,
	...rest
}, ref) => {
	return (
		<IconButton
			ref={ref}
			size="s"
			className={clsx(
				'data-active:not-hover:bg-transparent!',
				className,
			)}
			tooltip={tooltip ?? (variant === 'favourite' ? ['Favourite', 'Unfavourite'] : ['Pin', 'Unpin'])}
			{...rest}
		>
			{variant === 'favourite' && (
				<>
					<KidStarOutline
						className={clsx(
							'absolute inset-0 m-auto transition-all!',
						)}
					/>
					<KidStarFilled
						className={clsx(
							'absolute inset-0 m-auto transition-all!',
							'opacity-0 scale-0 group-data-active:opacity-100 group-data-active:scale-100',
							'duration-300 ease-out',
							'origin-center',
						)}
					/>
				</>
			)}
			{variant === 'pin' && (
				<>
					<PushPinOutlined
						className={clsx(
							'absolute inset-0 m-auto transition-all!',
							'rotate-45 opacity-100 duration-500 group-data-active:opacity-0 group-data-active:duration-150',
						)}
					/>
					<PushPin
						className={clsx(
							'absolute inset-0 m-auto transition-all!',
							'-translate-y-1/2 opacity-0 duration-300 group-data-active:translate-y-0 group-data-active:opacity-100 group-data-active:duration-500',
						)}
					/>
				</>
			)}
		</IconButton>
	);
});

